// Dashboard statistics hook

import { useState, useEffect } from 'react';
import { dashboardApi } from '../utils/api';
import type { DashboardStats } from '../types';

export const useDashboardStats = () => {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Use static fallback data for now to prevent network errors
      // TODO: Fix API endpoint to return proper JSON response
      setStats({
        chapters: 0,
        members: 0,
        upcoming_events: 0,
        published_reports: 0
      });
      
      // Uncomment when API is fixed:
      // const data = await dashboardApi.getStats();
      // setStats(data);
    } catch (err: any) {
      // Handle empty responses or parsing errors gracefully
      const message = err.response?.data?.error || err.message || 'Failed to fetch statistics';
      setError(message);
      // Set fallback stats to prevent UI errors
      setStats({
        chapters: 0,
        members: 0,
        upcoming_events: 0,
        published_reports: 0
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return {
    stats,
    isLoading,
    error,
    refetch: fetchStats,
  };
};
